/**
 * Superficie pública del módulo POS. Re-exporta desde domain-api y app-api + UI directa.
 * Para evitar require cycles, importar solo types desde `pos/domain-api`.
 */
// Side-effect import movido a src/init/sessionResetRegistrations.ts (cargado en App.tsx).

export * from './domain-api';
export * from './app-api';

// UI — se mantiene directo en public-api (components/screens importan de otros módulos)
export { PosProductCatalogList } from './components/catalog/PosProductCatalogList';
export { PosCartSection } from './components/cart/PosCartSection';
export { PosMobileCartBar, PosMobileCartSheet } from './components/PosMobileCartDock';
export { styles } from './components/posShared.styles';
export { PosCartProvider } from './components/contexts/PosCartContext';
export { PosBarcodeImportModal } from './components/modals/PosBarcodeImportModal';
export { PosVariousModal } from './components/modals/PosVariousModal';
export { DiningTablePickerModal } from './components/modals/DiningTablePickerModal';
export { PosCheckoutModal } from './components/checkout/PosCheckoutModal';
export { PosStockNoticeModal } from './components/modals/PosStockNoticeModal';
export { PosWeightQuantityModal } from './components/modals/PosWeightQuantityModal';
export { PosVariantPickerModal } from './components/modals/PosVariantPickerModal';
export { PosMenuOptionsModal } from './components/modals/PosMenuOptionsModal';
export { PosCheckoutProvider } from './components/contexts/PosCheckoutContext';
export { PosTrialBanner } from './components/PosTrialBanner';
export type { PosBarcodeImportConfirmPayload } from './components/modals/PosBarcodeImportModal';
export type { PosHeaderSectionProps } from './components/catalog/PosHeaderSection';
export { PosScreen } from './screens/PosScreen';
